import { FunctionComponent } from "react";

export const About: FunctionComponent = () => {
  return (
    <div>
      <p>About</p>
    </div>
  );
};
